module.exports = __webpack_public_path__ + "img/page1-dynamic-shadow.a30e320f.png";